import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import css from "../../css/listing/snapshot.module.css";
import { differenceInDays, parseISO } from "date-fns";
import { convertSquareFeetToAcres } from "../../service/listing";

const Snapshot = (props) => {
    const { listing } = props;

    const [days, setDays] = useState(null);

    useEffect(() => {
        setDays(differenceInDays(new Date(), parseISO(listing.listed_date)));
    }, [listing.listed_date]);

    const { participant } = listing;
    const { lot_size, living_area } = listing;

    return (
        <div className={css.snapshot}>
            <div className={css.row}>
                <div className={css.column}>
                    <div className={css.label}>Property Type</div>
                    <div className={css.value}>
                        {listing.property_sub_type.label}
                    </div>
                </div>
                <div className={css.column}>
                    <div className={css.label}>Lot Size</div>
                    <div className={css.value}>
                        {lot_size && lot_size > 0 && (
                            <>
                                {convertSquareFeetToAcres(
                                    lot_size
                                ).toLocaleString()}{" "}
                                acres
                            </>
                        )}
                    </div>
                </div>
            </div>
            <div className={css.row}>
                <div className={css.column}>
                    <div className={css.label}>Property Sqft</div>
                    <div className={css.value}>
                        {living_area > 0 && living_area.toLocaleString()}
                    </div>
                </div>
                <div className={css.column}>
                    <div className={css.label}>MLS Number</div>
                    <div className={css.value}>
                        {participant &&
                            participant.mls &&
                            participant.mls.number}
                        {!participant && listing.mls_number}
                    </div>
                </div>
            </div>
            <div className={css.row}>
                <div className={css.column}>
                    <div className={css.label}>Year Built</div>
                    <div className={css.value}>{listing.year_built}</div>
                </div>
                <div className={css.column}>
                    <div className={css.label}>Days On Market</div>
                    <div className={css.value}>{days}</div>
                </div>
            </div>

            {listing.source === "user" && (
                <div className={css.row}>
                    <div className={css.column}>
                        <div className={css.label}>Source</div>
                        <div className={css.value}>
                            {listing.agent
                                ? "Listing Agent / Residential.com"
                                : "Owner"}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

Snapshot.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default Snapshot;
